<template>
  <div>

    <vx-card id="autoCallSystemDataContainer" title=" " class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <span v-if="isManager === false" v-text="`${$t('extension_number')}: ${extension}`" class="mr-4 font-semibold" />
<!--        <v-select v-if="isManager === false" :disabled="formData.isStarted" :options="options.multiple" :reduce="label => label.value" :placeholder="$t('auto_call_system_multiple')" v-model="formData.multiple" class="d-inline" style="width:200px; margin: 0px 5px 0px 0px !important"/>-->
        <select v-if="isManager === false"  :disabled="formData.isStarted" v-model="formData.multiple"  class="vs-inputx vs-input--input normal d-inline" style="width:200px; margin: 0px 5px 0px 0px !important">
          <option value="">{{ $t('auto_call_system_multiple') }}</option>
          <option v-for="(option, key) in options.multiple" :key="'category_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <shared-auto-call-system-public-tab-nav @uploadExcelPopup="uploadExcelPopup" @exportExcelPopup="exportExcelPopup" @deletePopup="deletePopup" @start="start" @stop="stop" :isManager="isManager" :isStarted="formData.isStarted"></shared-auto-call-system-public-tab-nav>
      </template>
      <div class="auto-call-system-report">
        <p>
          <span class="report-value" v-text="report.totalUpload"/>
          <span class="report-label" v-text="$t('total_upload')"/>
        </p>
        <p>
          <span class="report-value" v-text="report.complete"/>
          <span class="report-label" v-text="$t('complete')"/>
        </p>
        <p class="success-report">
          <span class="report-value" v-text="report.success"/>
          <span class="report-label" v-text="$t('auto_call_system_success')"/>
        </p>
        <p class="block-report">
          <span class="report-value" v-text="report.block"/>
          <span class="report-label" v-text="$t('auto_call_system_block')"/>
        </p>
        <p class="machine-report">
          <span class="report-value" v-text="report.machine"/>
          <span class="report-label" v-text="$t('auto_call_system_machine')"/>
        </p>
        <p class="listen-hangup-report">
          <span class="report-value" v-text="report.listenHangup"/>
          <span class="report-label" v-text="$t('auto_call_system_listenhangup')"/>
        </p>
        <p class="dropcall-report">
          <span class="report-value" v-text="report.dropcall"/>
          <span class="report-label" v-text="$t('auto_call_system_dropcall')"/>
        </p>
        <div class="progress-container">
          <div class="progress-label"><span v-text="$t('auto_call_system_rate')" />:</div>
          <div class="progress-bar-container">
            <div class="progress-text">0%</div>
            <div class="progress-bar" :data-progress="report.rate"></div>
          </div>
        </div>
        <div class="dashboard-button-container">
          <vs-button
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-trash"
            @click="deleteAll"
          >
            <span v-text="$t('delete_all')" class="m-0 p-0" />
          </vs-button>
        </div>
        <div class="clearfix"></div>
      </div>
      <shared-auto-call-system-public-list
        :records="records"
      ></shared-auto-call-system-public-list>

      <template slot="footer">
        <paginate
          :total="lastpage"
          :click-handler="loadData"
          :value="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

  </div>
</template>

<script>

import SharedAutoCallSystemPublicTabNav from '@/views/Shared/AutoCallSystemPublic/TabNav'
import AutoCallSystem from '@/models/AutoCallSystem'
import Paginate from '@/mixins/paginate'
import SharedAutoCallSystemPublicList from '@/views/Shared/AutoCallSystemPublic/List'
import Utils from '@/helpers/utils'

export default {
  name: 'Window.AutoCallSystemPublic.Dashboard',
  mixins: [Paginate],
  components: {
    SharedAutoCallSystemPublicList,
    SharedAutoCallSystemPublicTabNav
  },
  data () {
    return {
      pbxDashboardInterval: null,
      report: {
        totalUpload: 0,
        complete: 0,
        success: 0,
        block: 0,
        busy: 0,
        machine: 0,
        listenHangup: 0,
        dropcall: 0,
        rate: 0
      },
      records: {},
      recordIds: [],
      formData: {
        multiple: null,
        isStarted: false
      },
      lastpage: 1,
      searchParams: {},
      isManager: false,
      options: {},
      data: []
    }
  },
  watch: {
    formData: {
      handler (newValue) {
        let multiple = ''
        if (newValue.multiple === null) {
          multiple = null
        } else {
          multiple = newValue.multiple
        }
        this.setCookie('multiple', multiple)

        let isStarted = false
        if (newValue.isStarted === null) {
          isStarted = false
        } else {
          isStarted = newValue.isStarted
        }
        this.setCookie('isStarted', isStarted)
      },
      deep: true
    },
    report: {
      handler (newValue) {
        if (newValue.rate === null) {
          this.report.rate = newValue.rate
        }
        const progressBar = document.querySelector('.progress-bar')
        const progressText = document.querySelector('.progress-text')
        const initialWidth = `${progressBar.getAttribute('data-progress')}%`

        progressBar.style.width = initialWidth
        progressText.innerText = initialWidth
      },
      deep: true
    }
  },
  computed: {
    servers () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    },
    extension () {
      return this.$store.getters.extension
    }
  },
  mounted () {
    this.loadData(this.initialPage)
    this.formData.multiple = this.getCookie('multiple')
    if (this.formData.multiple === null || this.formData.multiple === 'null') {
      this.formData.multiple = 2
    }
    if (this.getCookie('isStarted') === 'true') {
      this.formData.isStarted = true
    } else {
      this.formData.isStarted = false
    }
    if (this.pbxDashboardInterval === null) {
      this.pbxDashboardInterval = setInterval(this.sendRequestToPBX, 6000)
    }
    this.$windowOpenerHelper.listenToPopUpMessage('reload_auto_call_system_public_table', this.reloadData)
  },
  destroyed () {
    if (this.pbxDashboardInterval !== null) {
      clearInterval(this.pbxDashboardInterval)
      this.pbxDashboardInterval = null
    }
  },
  methods: {
    reloadData () {
      this.loadData(this.initialPage)
    },
    async loadData (page = 1, backToPageOne = false) {
      this.$vs.loading({container: '#autoCallSystemDataContainer'})
      const response = await AutoCallSystem.all({ ...this.searchParams, page })
      this.records = response.data.data.records
      this.recordIds = response.data.data.recordIds
      this.lastpage = response.data.meta.pagination.last_page
      this.isManager = response.data.meta.isManager
      this.options = response.data.meta.options
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#autoCallSystemDataContainer > .con-vs-loading')
    },
    uploadExcelPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'upload-auto-call-system-data', {})
    },
    exportExcelPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'export-auto-call-system-data', {})
    },
    deletePopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'delete-auto-call-system-data', {})
    },
    async start () {
      if (this.formData.multiple === null) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: this.$t('multiple_field_is_required'),
          confirmButton: this.$t('confirm')
        })
      } else if (this.extension === null || this.extension === '') {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: this.$t('extension_field_is_required'),
          confirmButton: this.$t('confirm')
        })
      }

      const response = await AutoCallSystem.checkAgentQueueStatus({domain: this.servers.domain, extension: this.extension, requestFrom: 'autocall-start-extension-validation'})

      if (response.data.success === true) {
        this.formData.isStarted = true
      } else {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: response.data.message,
          confirmButton: this.$t('confirm')
        })
      }
    },
    stop () {
      this.formData.isStarted = false
    },
    async sendRequestToPBX () {
      const response = await AutoCallSystem.sendDataToPBX({domain: this.servers.domain, extension: this.extension, started: this.formData.isStarted, multiple: this.formData.multiple, requestFrom: 'autocall-validate-extension-before-sending-data-to-pbx', recordIds: this.recordIds})
      if (response.data.updatedRecords.length > 0) {
        this.records.forEach(function (element) {
          response.data.updatedRecords.forEach(function (element2) {
            if (element.id === element2.id) {
              element.status = element2.status
              element.hangup_time = element2.hangup_time
            }
          })
        })
      }
      if (response.data.stop === true) {
        this.formData.isStarted = false
        this.$swalHelper.success({
          title: this.$t('auto_call_system_all_calls_are_finished'),
          confirmButton: this.$t('confirm')
        })
      }
      this.report = response.data.report
    },
    setCookie (key, val) {
      const cookieName = key
      const cookieValue = val
      const expires = new Date(`${Date.now()} + 7 * 24 * 60 * 60 * 1000`).toUTCString() // Expires in 7 days
      document.cookie = `${cookieName}=${cookieValue}; expires=${expires}; path=/`
    },
    getCookie (key) {
      const cookies = document.cookie.split('; ')
      for (const cookie of cookies) {
        const [name, value] = cookie.split('=')
        if (name === key) {
          return value
        }
      }
      return null // Cookie not found
    },
    async deleteAll () {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$i18n.t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })
      if (confirm.value) {
        try {
          await AutoCallSystem.destroy({extension: this.extension})
          this.reloadData()
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    }
  }
}
</script>

<style scoped>

.auto-call-system-report {
  margin: 0px 0px 20px 0px;
}
.auto-call-system-report p {
  float: left;
  margin: 5px;
  padding: 10px;
  border: solid 1px #ccc;
  min-width: 150px;
  border-radius: 5px;
}

.auto-call-system-report p .report-label {
  display: block;
  text-align: right;
  font-weight: bold;
}

.auto-call-system-report p .report-value {
  text-align: right;
  display: block;
  font-size: 17px;
}

.auto-call-system-report p.dropcall-report {
  background-color: #dc3545;
  color: #f1f1f1;
  border-color: #dc3545;
}

.auto-call-system-report p.listen-hangup-report {
  background-color: #6c757d;
  color: #fff;
  border-color: #808a93;
}

.auto-call-system-report p.machine-report {
  background-color: #17a2b8;
  color: #fff;
  border-color: #21bad3;
}
.auto-call-system-report p.busy-report {
  background-color: #ffc107;
  color: #fff;
  border-color: #ffc619;
}
.auto-call-system-report p.block-report {
  background-color: #343a40;
  color: #fff;
  border-color: #495158;
  display: none;
}
.auto-call-system-report p.success-report {
  background-color: #28a745;
  color: #fff;
  border-color: #33c354;
}

.progress-container, .dashboard-button-container {
  display: inline-flex;
  align-items: center;
  margin: 22px;
}

.progress-label {
  font-size: 18px;
  margin-right: 5px;
}

.progress-bar-container {
  background-color: #f0f0f0;
  border-radius: 10px;
  height: 30px;
  width: 150px; /* Adjust width as needed */
  margin-left: 5px; /* Adjust spacing as needed */
  position: relative;
}

.progress-bar {
  height: 100%;
  border-radius: 10px;
  background-color: #4caf50;
  position: absolute;
  width: 0;
  transition: width 0.5s ease; /* Add smooth transition */
}

.progress-text {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  line-height: 30px;
  color: #626262;
  font-weight: bold;
  z-index: 1;
}

</style>
